import InfoMessage from "./InfoMessage";
import { StackedLogo } from "./Logos";
import Button from "./Button";
import { useNavigate } from "react-router-dom";
import { HomeIcon } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <InfoMessage>
      <StackedLogo />
      <div className="my-10 flex flex-col items-center gap-4">
        <span className="text-2xl font-bold">Not Found</span>
        <p>Sorry, the page you are looking for does not exist.</p>
      </div>
      <Button border onClick={() => navigate("/")}>
        <HomeIcon className="w-4 h-4" />
        Go Home
      </Button>
    </InfoMessage>
  );
}
